export type ScopeCriteria = {
  [key: string]: boolean | any;
}[];

export interface FilterTabItem {
  id: string;
  key?: string;
  value: number | any;
  active?: boolean;
  translate?: {
    key: string;
    value?: any;
  };
}

export const anonymousViews: ScopeCriteria = [{ 'anonymous.enabled': true }];
export const authenticatedViews: ScopeCriteria = [
  { 'authenticated.enabled': true },
  { 'authenticated.isRestricted': false },
];
export const RestrictedViews: ScopeCriteria = [
  { 'authenticated.isRestricted': true },
];
